export default {
  lineNumberColor: `#c0c5ce`,
  lineNumberBgColor: `#1C1D21`,
  backgroundColor: `#1C1D21`,
  textColor: `#c0c5ce`,
  substringColor: `#c0c5ce`,
  keywordColor: `#B45EA4`,
  attributeColor: `#EE7C2B`,
  selectorAttributeColor: `#B45EA4`,
  docTagColor: `#c0c5ce`,
  nameColor: `#EB3C54`,
  builtInColor: `#E7CE56`,
  literalColor: `#E7CE56`,
  bulletColor: `#4FB4D7`,
  codeColor: `#c0c5ce`,
  additionColor: `#4FB4D7`,
  regexpColor: `#EB3C54`,
  symbolColor: `#4FB4D7`,
  variableColor: `#EB3C54`,
  templateVariableColor: `#EB3C54`,
  linkColor: `#E7CE56`,
  selectorClassColor: `#EB3C54`,
  typeColor: `#E7CE56`,
  stringColor: `#4FB4D7`,
  selectorIdColor: `#EB3C54`,
  quoteColor: `#B6B18B`,
  templateTagColor: `#c0c5ce`,
  deletionColor: `#EB3C54`,
  titleColor: `#78BB65`,
  sectionColor: `#78BB65`,
  commentColor: `#B6B18B`,
  metaKeywordColor: `#c0c5ce`,
  metaColor: `#E7CE56`,
  functionColor: `#c0c5ce`,
  numberColor: `#E7CE56`,
}
